export default (props, traits) => {
  const { banner } = props
  const { rhythm, mediaQuery } = traits

  return {
    root: {
      position: 'relative',
      background: `url(${banner}) no-repeat center`,
      backgroundSize: 'cover',
      paddingBottom: '25%'
    },

    bannerCTA: {
      position: 'absolute',
      zIndex: 5,
      bottom: '4px',
      right: '4px',
      padding: `${rhythm(0.5)} ${rhythm(0.25)}`,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      fontSize: rhythm(0.5),
      lineHeight: 1.0,
      textTransform: 'uppercase',
      [mediaQuery('xs')]: {
        bottom: rhythm(0.5),
        right: rhythm(0.5)
      }
    },

    sticker: {
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      width: '9vw',
      maxWidth: rhythm(3)
    }
  }
}
